import React, { useState } from 'react'
import Cookies from 'js-cookie'

import { useTranslation } from '@mc/i18n'
import {
  Modal,
  ModalContent,
  ModalClose,
  IconBoltDefault,
  Button,
} from '@mc/design-system'

import { PROGRAMS_ANNOUNCEMENT_COOKIE_MODAL } from '../constants'
import { MAW_I18N_NAMESPACE } from '../../i18n/i18nInstance'
import classes from './EnterpriseAnnouncementModal.module.scss'

export const ProgramsModal = () => {
  const { t } = useTranslation(MAW_I18N_NAMESPACE)

  const cookieDisplayed =
    Cookies.get(PROGRAMS_ANNOUNCEMENT_COOKIE_MODAL) === 'true'
  const [show, setShow] = useState(!cookieDisplayed)

  const onClose = () => {
    Cookies.set(PROGRAMS_ANNOUNCEMENT_COOKIE_MODAL, 'true')
    setShow(false)
  }

  const ANNOUNCEMENTS = [
    'modal.bullets.bullet1',
    'modal.bullets.bullet2',
    'modal.bullets.bullet3',
  ]

  return (
    <Modal
      size='medium'
      show={show}
      onClose={onClose}
      canClickOutsideToClose={false}
    >
      <ModalContent className='mc-invert mc-text-color--dark mc-overflow--hidden'>
        <ModalClose />
        <div className='mc-theme-light mc-bg-light mc-p-9'>
          <h1 className={`${classes.title} mc-text-d1`}>{t('modal.title')}</h1>
          <p className='mc-opacity--muted mc-mb-4'>{t('modal.description')}</p>

          <ul>
            {ANNOUNCEMENTS.map((announcementI18nPrefix, index) => (
              <li key={index} className='d-flex mc-mb-4'>
                <div>
                  <IconBoltDefault className='mc-mr-4' />
                </div>
                <div>
                  <h2 className='mc-text-h6'>
                    {t(`${announcementI18nPrefix}.title`)}
                  </h2>
                  <p className='mc-opacity--muted mc-text-small'>
                    {t(`${announcementI18nPrefix}.description`)}
                  </p>
                </div>
              </li>
            ))}
          </ul>

          <Button
            fullWidth
            as='a'
            href='/homepage/programs'
            className='mc-mt-4'
            onClick={onClose}
          >
            <span className='mc-text-x-small mc-text--uppercase'>
              {t('cta')}
            </span>
          </Button>
        </div>
      </ModalContent>
    </Modal>
  )
}
